import { Environment, isProduction } from '@vp/digital-environment-lib-ubik'
import {
  getWixPurchaseDomainNavigationUrl,
  getWixConnectDomainNavigationUrl,
  getWixMultilingualSubdomainHelpUrl,
  getWixRestrictedDomainExtensionsUrl,
  getWixTransferDomainNavigationUrl,
} from '@vp/digital-url-service-lib-ubik'
import { PartnerUrls } from '../../../common/types/Types'
import {
  getDomainRegistrationNavigationUrl,
  getWixConnectDomainBuildWebsiteNavigationUrl,
  getWixReviewAndBuyDomainNavigationUrl,
} from '@vp/digital-url-service-lib-ubik'
export function getPartnerUrls(
  requestor: string,
  locale: string,
  domainName?: string,
  siteId?: string,
  isPremium: boolean = false,
  source?: string,
): PartnerUrls {
  const wixPartnerConnectDomainUrl: string = getWixPartnerConnectDomainUrl(locale, requestor, domainName, siteId, source)
  const wixPartnerPurchaseDomainUrl: string = getWixPartnerPurchaseDomainUrl(locale, requestor, domainName, source)
  const vistaDomainRegistrationUrl: string = isPremium
    ? getPartnerDomainRegistrationNavigationUrl(locale, requestor, siteId, source)
    : getPartnerDomainRegistrationNavigationUrl(locale, requestor, undefined, source)
  const wixPartnerTransferDomainUrl: string = getWixPartnerTransferDomainUrl(locale, requestor, domainName, source)
  return {
    wixPartnerPurchaseDomainUrl,
    wixPartnerConnectDomainUrl,
    vistaDomainRegistrationUrl,
    wixPartnerTransferDomainUrl,
  }
}

export function getWixPartnerGetDomainsUrl(urlWixPartnerGetDomainsUrls: any): string {
  return isProduction() ? urlWixPartnerGetDomainsUrls.prod : urlWixPartnerGetDomainsUrls.qa
}

export function getWixPartnerPurchaseDomainUrl(locale: any, requestor: string, domainName: string, source?: string): string {
  return isProduction()
    ? getWixPurchaseDomainNavigationUrl(locale, requestor, domainName, '', Environment.Prod, source)
    : getWixPurchaseDomainNavigationUrl(locale, requestor, domainName, '', Environment.Staging, source)
}

export function getWixPartnerConnectDomainUrl(locale: any, requestor: string, domainName: string, siteId: string, source?: string): string {
  return isProduction()
    ? getWixConnectDomainNavigationUrl(locale, requestor, domainName, siteId, Environment.Prod, source)
    : getWixConnectDomainNavigationUrl(locale, requestor, domainName, siteId, Environment.Staging, source)
}

export function getPartnerDomainRegistrationNavigationUrl(locale: any, requestor: string, siteId?: string, source?: string): string {
  return isProduction()
    ? getDomainRegistrationNavigationUrl(locale, requestor, siteId, Environment.Prod, source)
    : getDomainRegistrationNavigationUrl(locale, requestor, siteId, Environment.Staging, source)
}

export function getWixPartnerTransferDomainUrl(locale: any, requestor: string, domainName: string, source?: string): string {
  return isProduction()
    ? getWixTransferDomainNavigationUrl(locale, requestor, domainName, '', Environment.Prod, source)
    : getWixTransferDomainNavigationUrl(locale, requestor, domainName, '', Environment.Staging, source)
}

export function getWixPartnerReviewAndBuyDomainUrl(
  locale: any,
  requestor: string,
  domainName: string,
  source?: string,
  siteId?: string,
  hasOwnDomain?: boolean,
): string {
  return isProduction()
    ? getWixReviewAndBuyDomainNavigationUrl(locale, requestor, domainName, Environment.Prod, source, siteId, hasOwnDomain)
    : getWixReviewAndBuyDomainNavigationUrl(locale, requestor, domainName, Environment.Staging, source, siteId, hasOwnDomain)
}

export function getWixPartnerConnectDomainBuildWebsiteUrl(
  locale: any,
  requestor: string,
  domainName: string,
  source?: string,
  siteId?: string,
  hasOwnDomain?: boolean,
): string {
  return isProduction()
    ? getWixConnectDomainBuildWebsiteNavigationUrl(locale, requestor, domainName, Environment.Prod, source, siteId, hasOwnDomain)
    : getWixConnectDomainBuildWebsiteNavigationUrl(locale, requestor, domainName, Environment.Staging, source, siteId, hasOwnDomain)
}

export function getWixPurchaseDomainUrl(partnerUrls: PartnerUrls) {
  return partnerUrls.wixPartnerPurchaseDomainUrl
}

export function getWixConnectDomainsUrl(partnerUrls: PartnerUrls) {
  return partnerUrls.wixPartnerConnectDomainUrl
}

export function getWixHelpPageUrls(languageCode: string) {
  const wixUnsupportedMultilangualDomainsUrl = getWixMultilingualSubdomainHelpUrl(languageCode)

  const wixOfacRestrictedDomainsUrl = getWixRestrictedDomainExtensionsUrl(languageCode)
  return { wixUnsupportedMultilangualDomainsUrl, wixOfacRestrictedDomainsUrl }
}

export function getVistaWixLegacyCustomerHelpUrl() {
  return '/customer-care/help-center/22444715799693/'
}
